var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarketInsights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 14,
    fill: "#1F82FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1993_39126)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.6219 17.7313L38.1891 16.2985V12L33.7314 16.6169L33.413 20.2786L28.7961 24.8956C28.4777 24.8956 28.3185 24.8956 28.0001 24.8956C26.2489 24.8956 24.816 26.3284 24.816 28.0796C24.816 29.8309 26.2489 31.2637 28.0001 31.2637C29.7514 31.2637 31.1842 29.8309 31.1842 28.0796C31.1842 27.7612 31.1842 27.602 31.025 27.2836L35.6419 22.6667L39.3036 22.3483L43.9205 17.7313H39.6219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.597 24.0995H36.4378L34.2089 26.4875C34.3681 26.9652 34.3681 27.602 34.3681 28.0796C34.3681 31.5821 31.5024 34.4478 27.9999 34.4478C24.4974 34.4478 21.6318 31.5821 21.6318 28.0796C21.6318 24.5771 24.4975 21.7114 28 21.7114C28.6368 21.7114 29.1144 21.8706 29.5921 21.8706L31.9801 19.4825V19.3233C30.7065 18.8457 29.4329 18.5273 28 18.5273C22.7463 18.5273 18.4478 22.8258 18.4478 28.0796C18.4478 33.3333 22.7463 37.6318 28 37.6318C33.2538 37.6318 37.5523 33.3333 37.5523 28.0795C37.5523 26.6467 37.2338 25.3731 36.597 24.0995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4875 21.5532L40.0995 23.7821C40.4179 25.0557 40.7363 26.4886 40.7363 28.0806C40.7363 35.0856 35.005 40.8169 28 40.8169C20.995 40.8169 15.2637 35.0855 15.2637 28.0806C15.2637 21.0757 20.995 15.3443 28 15.3443C29.4328 15.3443 30.8657 15.6627 32.2985 16.1403V15.9811L34.6865 13.593C32.6169 12.6378 30.388 12.1602 28 12.1602C19.2437 12.1602 12.0796 19.3243 12.0796 28.0806C12.0796 36.8368 19.2437 44.001 28 44.001C36.7562 44.001 43.9203 36.8368 43.9203 28.0806C43.9203 25.6925 43.4428 23.4637 42.4875 21.5532Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1993_39126"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketInsights);
export default __webpack_public_path__ + "static/media/MarketInsights.3d1e9f43d5a2f3ec82ea3fc8356e6da1.svg";
export { ForwardRef as ReactComponent };